"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Wrath_OnAttackEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Wrath_OnAttackEventHandlerScript = class Effect_Wrath_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack) {
            return;
        }
        if (!event.args.hit) {
            return;
        }
        if (!container.hasEffectOfType(event.args.targetId, EffectType_1.EffectType.Weakness)) {
            container.applyDebuff({
                sequence,
                attackerId: handler.subject,
                targetId: event.args.targetId,
                effect: new __1.WeaknessEffectArgs(),
                duration: Duration_1.Duration.Turns(3),
            });
        }
    }
};
Effect_Wrath_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Wrath_OnAttack")
], Effect_Wrath_OnAttackEventHandlerScript);
exports.Effect_Wrath_OnAttackEventHandlerScript = Effect_Wrath_OnAttackEventHandlerScript;
